export default __webpack_public_path__ + "static/media/mode-37.0fa22c06.svg";